<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? `Editing: ${item.title} (${item.reference})` : 'Create New Document'" subtitle="Provide the main details of the Document in this section." class="py-8 border-b">
                <ui-input label="Title" name="title" :error="form.errors.get('title')" v-model="form.title" class="xl:col-span-6"></ui-input>
                <ui-input label="Reference" name="reference" :error="form.errors.get('reference')" v-model="form.reference" class="xl:col-span-6"></ui-input>
                <ui-toggle label="Requires Acknowledgement" text="Does this document required acknowledgement?" name="requires_acknowledgement" :error="form.errors.get('requires_acknowledgement')" v-model="form.requires_acknowledgement" class="xl:col-span-6"></ui-toggle>
                <ui-date-picker label="Review Due Date" name="renews_at" v-model="form.renews_at" class="xl:col-span-6" :error="form.errors.get('renews_at')"></ui-date-picker>
                <ui-input label="Section" name="section" :error="form.errors.get('section')" v-model="form.section" placeholder="Accounts, Vehicles, etc." class="xl:col-span-6"></ui-input>
                <ui-select-searchable
                    label="Limit To Specific Teams"
                    placeholder="Associate document with one or many teams..."
                    multiple
                    v-model="form.team_ids"
                    :error="form.errors.get('team_ids')"
                    :options="teams"
                    class="xl:col-span-6"
                ></ui-select-searchable>
            </ui-form-section>
        </ui-container>

        <ui-container>
            <ui-form-section title="Document" subtitle="Use this section to edit the document itself." class="py-8 border-b">
                <div class="col-span-full">
                    <textarea ref="body" :value="form.document.body" class="wysiwyg"></textarea>
                    <ui-hint :error="form.errors.get('document')"></ui-hint>
                </div>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new v-if="editMode" primary @click.prevent="form.submit()" :loading="form.busy">Edit</ui-button-new>
            <ui-button-new v-if="! editMode" @click.prevent="form.submit()" :loading="form.busy">Save As Draft</ui-button-new>
            <ui-button-new v-if="! editMode" primary @click.prevent="form.submit(true)" :loading="form.busy">Publish Document</ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import { Document } from '@models'

export default {
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
        teams: Array,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : { document: {} }

        return {
            editor: null,
            form: new Form(initialData, async (form, publish = false) => {
                if (this.editMode) {
                    await this.item.update({
                        ...form.export(),
                        document: this.editor.getData(),
                    })
                    this.edit(false)
                } else {
                    const document = await Document.create({
                        ...form.export(),
                        publish,
                        document: this.editor.getData(),
                    })
                    this.addItem(document, 0)

                    form.reset()
                }
            }),
        }
    },
    computed: {
        editMode() {
            return !! this.item
        },
    },
    async mounted () {
        await new Promise(resolve => setTimeout(resolve, 200))
        this.editor = await ClassicEditor.create(this.$refs.body, {
          extraAllowedContent: 'br'
        })
    },
    beforeDestroy () {
        this.editor.destroy()
    },
}
</script>
